import React from 'react';
import { usePlan } from '../../hooks/usePlan';
import { openPricingModal } from '../../utils/pricingModal';
import './planBadge.css';

/**
 * Small pill next to the app title: "Plus" (sky/primary), "Comp", or "Free".
 * A badge only ever shows once the plan is CONFIRMED (`resolved`) — the
 * loading/error fallback resolves to 'plus' in usePlan.js, so gating on
 * `resolved` prevents both a phantom "Plus" and a phantom "Free" flash.
 * The Free badge is a button into the pricing modal: free users should always
 * be able to see their plan state and reach the upgrade path from the header.
 */
function PlanBadge() {
  const { plan, loading, resolved } = usePlan();

  if (loading || !resolved) {
    return null;
  }

  if (plan === 'comp') {
    return <span className="plan-badge plan-badge--comp">Comp</span>;
  }

  if (plan === 'plus') {
    return <span className="plan-badge plan-badge--plus">Plus</span>;
  }

  if (plan === 'free') {
    return (
      <button
        type="button"
        className="plan-badge plan-badge--free"
        onClick={openPricingModal}
        title="You're on the Free plan — see plans and upgrade options"
      >
        Free
      </button>
    );
  }

  return null;
}

export default PlanBadge;
